import { TmFormElement } from '@thiememeulenhoff/lit-sdk';
import { IconName } from '@thiememeulenhoff/types';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { styles, tag } from './checkbox.styles';

@customElement(tag)
export class CheckboxComponent extends TmFormElement {
  static override styles = styles;

  override type = 'checkbox';

  @property({ type: String })
  icon: IconName = 'check';

  @property({ type: Boolean })
  error?: boolean;

  override handleFormData(event: Event) {
    const { formData } = event as FormDataEvent;
    const { disabled, name, checked, value = 'on' } = this;

    if (!disabled && checked) {
      formData.append(name ?? '', value);
    }
  }

  override render() {
    return html`
      <label data-test="checkbox-label">
        <slot name="prefix"></slot>
        <div class="input">
          ${this.inputTemplate()}
          <a-icon
            class="icon"
            name="${this.indeterminate ? 'dash' : this.icon}"
          ></a-icon>
        </div>
        <slot></slot>
      </label>
    `;
  }
}
